import { RequestMaker } from "./RequestMaker";
import { JsonCustomPage } from "../json-data-types/JsonCustomPage";
import { stringify } from "querystring";

const filename = 'ServerCustomPages'

export module ServerCustomPages{
    export async function getShortListAsync(){
        return await RequestMaker.sendWebsocketJsonRequestAsync<{id:string, name:string, url:string}[]>({
            query:'custompages-short-list',
            params:{}
        }, filename)
    }
}